// Import components.
import PrivacyManagement from './components/PrivacyManagement.jsx';
import PrivacyPopup from './components/PrivacyPopup.jsx';
import PrivacySettingsButton from './components/PrivacySettingsButton.jsx';
import CookiesDisabledModal from './components/CookiesDisabledModal.jsx';

/**
 * <pre>
 * PrivacyManagement module React Components.
 *
 * Summary of responsibilities:
 *
 *  - defines React components that this app module can render
 * </pre>
 *
 * @memberof module:PrivacyManagement
 * @namespace
 *
 * @type {Object}
 */
const Components = {
  PrivacyManagement,
  PrivacyPopup,
  PrivacySettingsButton,
  CookiesDisabledModal,
};

export default Components;